const config = {
    dropdownButtonSelector: '.js-dropdown--button',
    dropdownContentSelector: '.c-dropdown__content',
    openModifier: 'is-open'
};

$(document).ready(function () {
    const myDropdownButtons = $(config.dropdownButtonSelector);
    myDropdownButtons.on('click', function (e) {
        e.preventDefault();
        const myDropdown = $('.' + $(this).attr('id'));

        if (myDropdown.hasClass(config.openModifier)) {
            myDropdown.removeClass(config.openModifier);
        } else {
            myDropdown.addClass(config.openModifier);
        }
    });
    $(window).click(function (e) {
        const dropdown = $(e.target);
        if (dropdown.closest(config.dropdownButtonSelector).length === 0) {
            const allDropdowns = $(config.dropdownContentSelector);
            allDropdowns.removeClass(config.openModifier);
        }
    });
});



// WEBPACK FOOTER //
// ./src/js/components/dropdown.js